var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.706 9.619a4.309 4.309 0 0 0-3.094-3.094C28.913 5.794 18 5.794 18 5.794s-10.912 0-13.613.731a4.309 4.309 0 0 0-3.093 3.094C.562 12.375.562 18 .562 18s0 5.681.732 8.381a4.309 4.309 0 0 0 3.093 3.094c2.7.731 13.613.731 13.613.731s10.913 0 13.613-.731a4.309 4.309 0 0 0 3.093-3.094c.731-2.7.731-8.381.731-8.381s0-5.625-.73-8.381ZM14.512 23.23V12.77L23.57 18l-9.056 5.231Z",
    fill: "#292723"
  })));
};
export default SvgYoutube;